<template>
  <FullPageLayout>
    <div class="mx-auto mt-8 flex w-full max-w-[1100px]">
      <div class="hidden sm:block left-panel flex-shrink-0 w-[260px]">
        <CorporateMenu />
      </div>

      <div class="policy mx-4 sm:ml-8 w-full child__container">
        <h1>Onedio Bilişim Yazılım Medya Teknoloji San. Ve Tic. A.Ş. Ziyaretçi Aydınlatma Metni</h1>
        <div style="max-height: 100%" class="cont space-y-4 my-8">
          <p>
            6698 Sayılı Kişisel Verilerin Korunması Kanunu (
            <b>Kanun</b>
            ) 7 Nisan 2016 tarihinde yürürlüğe girmiş olup ilgili Kanun, kimliği belirli veya belirlenebilir gerçek kişilere ilişkin her
            türlü bilginin işlenmesine ilişkin düzenlemeleri içermektedir.
          </p>
          <p>
            Bu metin, Onedio’nun faaliyette bulunduğu fiziki mekânları ziyaret eden ziyaretçilere ait kişisel verilerin Kanun çerçevesinde
            işlenmesi kapsamındaki Onedio’nun beyan ve açıklamalarını içermektedir. Bu minvalde, metnin uygulama alanı, Onedio’nun fiziki
            ziyaretçilerine ait kişisel verilerin işlenme süreçleridir. Lütfen bu aydınlatma yükümlülüğünü dikkatlice okuyarak, işlenen
            verilerinize ilişkin prosedürleri inceleyiniz. Kanun uyarınca kişisel verileriniz; veri sorumlusu olarak Onedio Bilişim Yazılım
            Medya Teknoloji San. Ve Tic. A.Ş. (
            <b>Onedio</b>
            veya
            <b>Şirket</b>
            ) tarafından aşağıda açıklanan kapsamda işlenebilecektir. Bu metinde yer alan;
          </p>
          <p>
            <b>Açık Rıza:</b>
            Belirli bir konuya ilişkin, bilgilendirilmeye ve özgür iradeye dayanan, tereddüte yer bırakmayacak açıklıkta, sadece o işlemle
            sınırlı olarak verilen onayı,
          </p>
          <p>
            <b>Anonim Hale Getirme:</b>
            Kişisel verilerin, başka verilerle eşleştirilerek dahi hiçbir surette kimliği belirli veya belirlenebilir bir gerçek kişiye
            ilişkilendirilemeyecek hale getirilmesini,
          </p>
          <p>
            <b>Kişisel Veri Sahibi (İlgili Kişi):</b>
            Kişisel verisi işlenen gerçek kişiyi,
          </p>
          <p>
            <b>Kişisel Veri:</b>
            Kimliği belirli veya belirlenebilir gerçek kişiye ilişkin her türlü bilgiyi,
          </p>
          <p>
            <b>Özel Nitelikli Kişisel Veri:</b>
            Kişilerin, ırkı, etnik kökeni, siyasi düşüncesi, felsefi inancı, dini, mezhebi, veya diğer inançları, kılık ve kıyafeti, dernek,
            vakıf ya da sendika üyeliği, sağlığı, cinsel hayatı, ceza mahkumiyeti, ve güvenlik tedbirleriyle ilgili verileri ile biyometrik
            ve genetik verileri,
          </p>
          <p>
            <b>Kişisel Verilerin İşlenmesi:</b>
            Kişisel verilerin tamamen veya kısmen otomatik olan ya da herhangi bir veri kayıt sisteminin parçası olmak kaydıyla otomatik
            olmayan yollarla elde edilmesi, kaydedilmesi, depolanması, saklanması, değiştirilmesi, yeniden düzenlenmesi, açıklanması,
            aktarılması, devralınması, elde edilebilir hale getirilmesi, sınıflandırılması ya da kullanılmasının engellenmesi gibi veriler
            üzerinde gerçekleştirilen her türlü işlemi,
          </p>
          <p>
            <b>Veri Sorumlusu:</b>
            Kişisel verilerin işleme amaçlarını ve vasıtalarını belirleyen, veri kayıt sisteminin kurulmasında ve yönetilmesinden sorumlu
            gerçek veya tüzel kişiyi,
          </p>
          <p>
            <b>Ziyaretçi:</b>
            Onedio’nun fiziken faaliyet gösterdiği mekânları herhangi bir amaçla ziyaret edn gerçek kişiyi ifade eder.
          </p>
          <h2>Veri Kategorileri ve Veri Türleri</h2>
          <p></p>
          <table>
            <tbody>
              <tr>
                <td rowspan="3"><b>Ziyaretçi</b></td>
                <td><b>Fiziksel Mekan Güvenliği</b></td>
                <td><span>Kamera Kayıtları</span></td>
              </tr>
              <tr>
                <td><b>Görsel Kayıtlar</b></td>
                <td><span>Kamera Kayıtları</span></td>
              </tr>
              <tr>
                <td><b>Hukuki İşlem ve Uyum Bilgisi</b></td>
                <td><span>MAC bilgisi, Erişim Kayıtları ve ilgili log kayıtları</span></td>
              </tr>
            </tbody>
          </table>
          <p></p>
          <h2>Kişisel Verileri Toplama Yöntemleri ve Hukuki Sebepleri</h2>
          <p></p>
          <p>
            İnternet kullanımı sebebiyle işlenen kişisel verileriniz başta 5651 sayılı İnternet Ortamında Yapılan Yayınların Düzenlenmesi ve
            Bu Yayınlar Yoluyla İşlenen Suçlarla Mücadele Edilmesi Hakkında Kanun, 5809 sayılı Elektronik Haberleşme Kanunu, İnternet Toplu
            Kullanım Sağlayıcıları Hakkında Yönetmelik başta olmak üzere, kamuya açık alanlarda internet erişimi sağlayan toplu kullanım
            sağlayıcıların kullanıcıları tanımlayacak sistemleri kurma yükümlülüğü kapsamında toplanmakta ve işlenmektedir.
          </p>
          <p>
            Şirketimiz, kişisel verileri, doğrudan ziyaretçilerin kendisinden, ofis yerleşkelerinde, işyerlerinde, eklentilerinde, denetim
            alanlarında, avlularında, giriş kapıları, ofis alanı girişleri, etkinlik alanları, yemekhane, kafeterya, ziyaretçi bekleme
            salonu ve kat koridorları ve diğer hizmet alanlarında bulunan CCTV sisteminden, internet erişildiği takdirde trafik/log
            kayıtları ve sair iletişim kanallarından, işitsel, elektronik veya yazılı olarak öğrenilen verilerden elde etmektedir. Bu
            şekilde elde edilen kişisel verileriniz, kanunlarda açıkça öngörülme (örneğin, 5651 sayılı Kanun uyarınca internet trafik
            kayıtlarının işlenmesi), hukuki yükümlülüğün yerine getirilmesi (örneğin, iş sağlığı/güvenliği kurallarına riayet edildiğinin
            takibi, bilgi güvenliğini sağlamak amacıyla çalışma alanlarına izinsiz girişlerin önlenmesi), veri sorumlusunun meşru menfaati
            (örneğin, fiziksel mekân güvenliğinin sağlanması amacıyla kamera kayıtlarının tutulması, işyeri kurallarına ilişkin ihlalleri
            tespit edilmesi ve soruşturulması) hukuki sebeplerine dayalı olarak işlenmektedir.
          </p>
          <p>
            Kişisel verilerinizi, hukuki yükümlülüğümüzü yerine getirebilmek için zorunlu olan durumlar, sizlere bir hak tesis etmemiz, bu
            hakkı kullandırmamız ve korumamız için veri işlemek zorunda oluşumuz ve temel hak ve özgürlüklerinize zarar vermemek kaydıyla,
            meşru menfaatlerimiz için veri işlenmesinin zorunlu olması sebeplerine dayanarak işlemekteyiz. Bu kapsamda, veri işlemenin
            ilgili mevzuat uyarınca zorunlu olduğu durumlarda, 5651 sayılı İnternet Ortamında Yapılan Yayınların Düzenlenmesi ve Bu Yayınlar
            Yoluyla İşlenen Suçlarla Mücadele Edilmesi Hakkında Kanun ile 5809 Elektronik Haberleşme Kanunu, 5237 sayılı Türk Ceza Kanununda
            yer alan hükümler başta olmak üzere suçla mücadele edilmesi, konusu suç oluşturan içeriklere erişimin engellenmesi, ailenin ve
            çocukların korunması, suçun önlenmesi ve suçluların tespiti, konusu suç oluşturan içeriklere erişimi önleyici tedbirler
            alınması, erişim engelleme ve filtreleme sistemlerinin etkinliğinin sağlanması ve trafiğin yönetimi gibi sebeplerle işliyoruz.
          </p>
          <h2>Kişisel Verilerin İşlenme Amaçları</h2>
          <p></p>
          <table>
            <tbody>
              <tr>
                <td><b>Fiziksel Mekan Güvenliği Görsel Kayıtlar</b></td>
                <td><span>Kamera Kayıtları</span></td>
                <td>
                  <ul>
                    <li>Ziyaretçi Kayıtlarının Oluşturulması Ve Takibi</li>
                    <li>Yetkili Kişi, Kurum Ve Kuruluşlara Bilgi Verilmesi</li>
                    <li>Veri Sorumlusu Operasyonlarının Güvenliğinin Temini</li>
                    <li>Taşınır Mal Ve Kaynakların Güvenliğinin Temini</li>
                    <li>Sözleşme Süreçlerinin Yürütülmesi</li>
                    <li>Saklama Ve Arşiv Faaliyetlerinin Yürütülmesi</li>
                    <li>Hukuk İşlerinin Takibi Ve Yürütülmesi</li>
                    <li>Fiziksel Mekan Güvenliğinin Temini</li>
                    <li>Faaliyetlerin Mevzuata Uygun Yürütülmesi</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td><b>Hukuki İşlem ve Uyum Bilgisi</b></td>
                <td><span></span></td>
                <td>
                  <ul>
                    <li>İç Denetim/ Soruşturma / İstihbarat Faaliyetlerinin Yürütülmesi</li>
                    <li>Faaliyetlerin Mevzuata Uygun Yürütülmesi</li>
                    <li>Denetim / Etik Faaliyetlerinin Yürütülmesi</li>
                    <li>Yetkili Kişi, Kurum Ve Kuruluşlara Bilgi Verilmesi</li>
                    <li>Veri Sorumlusu Operasyonlarının Güvenliğinin Temini</li>
                    <li>Hukuk İşlerinin Takibi Ve Yürütülmesi</li>
                    <li>Fiziksel Mekan Güvenliğinin Temini</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
          <p></p>
          <h2>İşlenen Kişisel Verilerin Kimlere ve Hangi Amaçla Aktarılabileceği</h2>
          <p></p>
          <p>
            Toplanan kişisel veriler, yukarıda belirtilen amaçların gerçekleştirilmesi doğrultusunda ve bu amaçların yerine getirilmesi ile
            sınırlı olarak; internet kullanım verileri için Wifi hizmet sunumu için altyapı sağlayan internet servis sağlayıcıları ve çözüm
            ortaklarıyla, hizmet sağlayıcılarımızla, hukuken yetkili kamu kurum ve kuruluşlarıyla, tedarikçilerimizle, Bilgi ve İletişim
            Teknolojileri Kurumu, cumhuriyet savcılıkları, kolluk kuvvetleri, mahkemeler ve ilgili adli ve idari merciler başta olmak üzere
            ş ortaklarımıza, tedarikçilerimize, kanunen yetkili kamu kurumlarına ve özel kişi veya kuruluşlar ile üçüncü kişilere Kanun’un
            8. ve 9. maddelerinde belirtilen kişisel veri işleme şartları ve yukarıda belirtilen amaçlarla sınırlı olarak aktarılabilecek,
            yurtiçinde veya yurtdışında işlenebilecektir.
          </p>
          <h2>Kişisel Veri Sahibi Olarak Haklarınız</h2>
          <p></p>
          <p>
            Kişisel veri sahipleri olarak, haklarınıza ilişkin taleplerinizi belirtmek ve kişisel verileriniz üzerindeki haklarınızı
            kullanmak amacıyla; resmi telefon hattı olan “+90 (312) 969 33 96” numarası üzerinden,
            <a href="/aydinlatma-metni/ilgili-kisi-basvuru-formu" target="blank">Ilgili Kisi Formu</a>
            adresinde yer alan “İlgili Kişi Başvuru Formu’nu doldurarak Onedio resmi e-mail adresi
            <a href="mailto:onedio@onedio.com" class="contact">onedio@onedio.com</a>
            veya veya ilgili formdaki adrese e-posta göndererek yahut yazılı başvurarak gerekli değişiklik, güncelleme ve/veya silme gibi
            işlemleri ve ilgili talepleri gerçekleştirebilirsiniz. Telefon üzerinden gerçekleştirilen taleplerde, ardından diğer usullere
            uygun bir başvuru yapılması için yönlendirme yapılacaktır .
          </p>
          <p></p>
          <p>
            Belirtilen yöntemlerle taleplerinizi bize iletmeniz durumunda Şirket, talebinizin niteliğine göre talebi en kısa sürede ve en
            geç otuz gün içinde ücretsiz olarak sonuçlandıracaktır. Ancak, işlemin ayrıca bir maliyeti gerektirmesi hâlinde, Şirket
            tarafından Kişisel Verileri Koruma Kurulu’nca belirlenen tarifedeki ücret alınacaktır. Bu kapsamda kişisel veri sahipleri;
          </p>
          <p></p>
          <ul style="list-style: none">
            <li>a) Kişisel veri işlenip işlenmediğini öğrenme,</li>
            <li>b) Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,</li>
            <li>c) Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
            <li>ç) Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme,</li>
            <li>d) Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme,</li>
            <li>e) Kanun’un 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerin silinmesini veya yok edilmesini isteme,</li>
            <li>
              f) (d) ve (e) bentleri uyarınca yapılan işlemlerin, kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,
            </li>
            <li>
              g) İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun
              ortaya çıkmasına itiraz etme,
            </li>
            <li>h) Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme.</li>
          </ul>
          <p></p>
          <p>
            Kişisel veri sahibi olarak sahip olduğunuz ve yukarıda belirtilen haklarınızı kullanmak için yapacağınız ve kullanmayı talep
            ettiğiniz hakka ilişkin açıklamalarınızı içeren başvuruda; talep ettiğiniz hususun açık ve anlaşılır olması, talep ettiğiniz
            konunun şahsınız ile ilgili olması veya başkası adına hareket ediyor iseniz bu konuda özel olarak yetkili olmanız ve yetkinizi
            belgelendirilmesi, başvurunun kimlik ve adres bilgilerini içermesi ve başvuruya kimliğinizi tevsik edici belgelerin eklenmesi
            gerekmektedir.
          </p>
          <p></p>
        </div>
      </div>
    </div>
  </FullPageLayout>
</template>
<script>
import { defineComponent, useContext, useMeta, useRoute } from '@nuxtjs/composition-api';
import FullPageLayout from '@/modules/common/components/layout/FullPageLayout';
import CorporateMenu from '~/modules/corporate/components/CorporateMenu';
import { HOST_URL } from '~/constants/config';
export default defineComponent({
  components: {
    CorporateMenu,
    FullPageLayout,
  },
  head: {},
  setup() {
    const route = useRoute();
    const { $cache } = useContext();
    $cache('public, max-age=60');
    useMeta(() => {
      const path = route.value.path;
      return { link: [{ hid: 'canonical', rel: 'canonical', href: HOST_URL + path }] };
    });
    return {};
  },
});
</script>
<style>
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 10px;
}
</style>
